import {Component, Input} from '@angular/core'
import {CustomerStory} from '../customer-stories-modal/customer-stories-modal.component'

@Component({
  selector: 'app-customer-story-preview',
  templateUrl: './customer-story-preview.component.html',
  styleUrls: ['./customer-story-preview.component.scss']
})
export class CustomerStoryPreviewComponent {

  @Input() customerStory: CustomerStory

}
